import React from "react";
import { Link } from "react-router-dom";

export default function ProjectBox({ projectData, projectcatslug }) {
  return (
    <>
      <div className="col-xl-6 col-lg-6 col-md-6">
        <div className="project-box-items style-margin">
          <div className="project-thumb">
            <Link
              to={`/${projectcatslug}/${projectData.slug}`}
              className="project-link-btn"
            >
              <img
                src={projectData.sort_img}
                alt={projectData.image_alt}
                title={projectData.image_title}
              />
              <img
                src={projectData.sort_img}
                alt={projectData.image_alt}
                title={projectData.image_title}
              />
              {projectData.pricing !== "" && (
                <span className="project-post-box text-light">
                  PRICE ₹{projectData.pricing}
                </span>
              )}
              {projectData.location !== "" && (
                <span className="project-post-box_Location text-light">
                  <i className="fa-solid fa-location-dot me-2"></i>{" "}
                  {projectData.location}
                </span>
              )}
            </Link>
          </div>
          <div className="project-content">
            <h3>
              <Link to={`/${projectcatslug}/${projectData.slug}`}>
                {projectData.title}
              </Link>
            </h3>
            <ul className="project-list">
              {projectData.inventory !== "" && (
                <li>
                  <p>
                    <i className="fa fa-file-text me-2" aria-hidden="true"></i>
                    Total{" "}
                    {projectData.catslug === "plots" ? "Units" : "Inventory"}
                  </p>
                  <p>{projectData.inventory}</p>
                </li>
              )}

              {projectData.year !== "" && (
                <li>
                  <p>
                    <i className="fa fa-calendar me-2" aria-hidden="true"></i>
                    Year
                  </p>
                  <p>{projectData.year}</p>
                </li>
              )}

              {projectData.progress_status !== "" && (
                <li>
                  <p>
                    <i className="fa fa-retweet me-2" aria-hidden="true"></i>
                    Status
                  </p>
                  <p>{projectData.progress_status}</p>
                </li>
              )}

              {projectData.area !== "" && (
                <li>
                  <p>
                    <i className="fa fa-area-chart me-2" aria-hidden="true"></i>
                    Carpet Area
                  </p>
                  <p>{projectData.area}</p>
                </li>
              )}

              {/* <li>
                <p>
                  <i className="fa-solid fa-location-dot me-2"></i>
                  Location
                </p>
                <p>{projectData.location}</p>
              </li> */}
              {projectData.pricing !== "" && (
                <li>
                  <p>
                    <i className="fa fa-inr me-2" aria-hidden="true"></i>
                    Pricing
                  </p>
                  <p>{projectData.pricing}</p>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
